import { useFeatureTabLock } from "./featureTabLock";
import { CHAT_TABBAR_LOCKED_SVG } from "./native-icons";

/** No web glyph: `withFeaturePermission` locks the web bar's item. */
export const ChatTabLock = () => {
  useFeatureTabLock({ tab: "chat", feature: "Chat", nativeSvg: CHAT_TABBAR_LOCKED_SVG });
  return null;
};
